<script>
import { mapActions, mapState } from 'vuex';
import { result } from 'lodash';
import moment from 'moment';
import snackbarMixin from '@/mixins/snackbar';
import axios from 'axios';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';

export default {
  name: 'Notes',
  components: {
  },
  mixins: [mainViewTabMixin, paginationMixin, snackbarMixin],
  props: {
    parentResource: {
      type: String,
      required: true,
    },
    parentResourceId: {
      type: Number,
      required: true,
    },
    path: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      isInitialized: false,
      noteList: [],
      currentUser: null,
    };
  },
  computed: {
    ...mapState(['notes']),
    ...mapState('notes', ['meta']),
  },
  created() {
    this.noteList = [{ id: null, text: '' }];
  },
  mounted() {
    this.fetchUser();
    this.fetchNotes();
  },
  methods: {
    ...mapActions('notes', ['saveNote']),
    fetchUser() {
      axios.get('/user', {
        params: {
          current: true,
        },
      })
        .then((response) => {
          this.currentUser = response.data.username;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchNotes() {
      let uri = '/';

      if (this.parentResource && this.parentResourceId) {
        uri += `${this.parentResource}/${this.parentResourceId}/`;
      }
      uri += 'note';

      axios.get(uri)
        .then((notes) => {
          this.noteList = [{ id: null, text: '' }];
          this.noteList[0][this.parentResource] = { id: this.parentResourceId };
          const self = this;
          if (notes.data) {
            notes.data.forEach((it) => {
              if (it[self.parentResource]) self.noteList.push(it);
              else console.log('Warning: A note does not contain the ID for the parentResource. Please return that ID on server site.');
            });
          }

          this.noteList.forEach((it) => { console.log(it.id); });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submit(index) {
      this.isLoading = true;

      const noteToSubmit = this.noteList[index];

      if (this.parentResource && this.parentResourceId) {
        this.noteList[this.parentResource] = this.parentResourceId;
      }

      this.saveNote(noteToSubmit)
        .then(() => {
          this.showSuccessMessage('Die Notiz wurde gespeichert.');
          this.fetchNotes();
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Es ist ein Fehler aufgetreten.');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY');
    },
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>

      <v-layout row wrap>
        <v-flex md12>
          <v-layout row wrap>
            <v-flex md10>
              <v-textarea
                v-model="noteList[0].text"
                label="Text"
                class="caption"
              />
            </v-flex>
            <v-flex md2>
              <v-card-actions>
                <v-btn @click.native="submit(0)"
                       color="green"
                       dark>
                  <v-icon>save</v-icon>
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <div v-for="(note, index) in noteList" :key="index">
        <v-layout row wrap>
          <v-flex md12>
            <v-layout v-if="note.id" row wrap>
              <v-flex md10>
                <v-textarea
                  v-model="note.text"
                  label="Text"
                  class="caption"
                  :disabled="note.createdBy != currentUser"
                />
              </v-flex>
              <v-flex md2>
                <v-flex md12>
                  <v-text-field
                    v-model="note.createdBy"
                    label="Autor"
                    class="caption"
                    :disabled="true"
                  />
                </v-flex>
                <v-flex md12>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-text-field
                        :value="formatDate(note.dateCreated)"
                        label="Erstellt am"
                        class="caption"
                        :disabled="true"
                      />
                    </v-flex>
                    <v-flex md6>
                      <v-btn @click.native="submit(index)"
                             color="green"
                             dark>
                        <v-icon>save</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>

    </v-container>
  </v-form>
</template>

<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
